<template>
  <div :class="cssClasses" role="alert">
    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      type: { type: String, default: 'info' }
    },
    computed: {
      cssClasses() {
        return `alert alert-${this.type}`
      }
    }
  }
</script>
